import type { ThumbnailType } from '@dacr/library'

const FILE_TYPE_THUMBNAIL: Record<string, ThumbnailType> = {
  AUDIO: 'audio',
  IMAGE: 'image',
  VIDEO: 'video',
  PDF: 'pdf',
  TEXT: 'text',
  CODE: 'code',
  TABLE: 'table',
  VECTOR: 'vector',
  ZIP: 'zip',
  THREE_D: '3d',
  GENERIC: 'generic',
  ADOBE_PHOTOSHOP: 'photoshop',
  ADOBE_ILLUSTRATOR: 'illustrator',
  ADOBE_INDESIGN: 'indesign',
  ADOBE_PREMIER_PRO: 'premiere',
  ADOBE_AFTER_EFFECTS: 'after-effects',
  ADOBE_AUDITION: 'audition',
  MS_EXCEL: 'excel',
  MS_WORD: 'word',
  MS_POWER_POINT: 'powerpoint',
  MS_ACCESS: 'access',
  MS_PUBLISHER: 'publisher',
  AUTODESK_AUTOCAD: 'autocad',
  AUTODESK_FUSION: 'fusion',
  AUTODESK_MAYA: 'maya',
  CINEMA_4D: 'cinema4d',
  DAVINCI_RESOLVE: 'davinci',
}

export const fileTypeToThumbnail = (type?: string | null): ThumbnailType =>
  FILE_TYPE_THUMBNAIL[type ?? ''] ?? 'generic'
